import { searchApi } from '../api/search'
import { useQuery } from '@tanstack/react-query'
import { searchOptions } from '../querykeys/catalouge'

export const useSearchData = (isEnabled = false) => {
  return useQuery([searchOptions.SEARCH], searchApi.searchOptions, {
    enabled: isEnabled,
    keepPreviousData: true,
    select: (data) => data?.data?.data,
    // onSuccess: (res) => {
    //   const data = res?.data;
    // },
    // onError: (err: any) => {
    //   const errData = err?.data;
    //   // toast.error(errData.message);
    // },
    refetchOnWindowFocus: false
  })
}
